import React from 'react';
import { VENUE_NAME } from '../constants';

export const WhereToStay: React.FC = () => {
  const alternatives = [
    { 
      name: "Western House Hotel", 
      description: "A high-quality 4-star hotel located at Ayr Racecourse.",
      taxiTime: "14 min taxi"
    },
    { 
      name: "The Fairburn Hotel", 
      description: "A boutique hotel situated in the heart of Mauchline.",
      taxiTime: "12 min taxi"
    },
    { 
      name: "Premier Inn", 
      description: "Reliable comfort with multiple locations across Ayr.",
      taxiTime: "10 min taxi"
    },
    { 
      name: "Travelodge", 
      description: "Convenient and affordable lodging near the town center.",
      taxiTime: "9 min taxi"
    }
  ];

  return (
    <div className="py-24 max-w-4xl mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="font-serif-display text-4xl md:text-5xl mb-4 text-black">Where to Stay</h2>
        <p className="text-sm tracking-[0.3em] text-[#8E806A] font-medium uppercase opacity-70">Accommodation</p>
      </div>

      <div className="bg-white p-8 md:p-12 shadow-sm border border-[#F5F2ED] rounded-sm mb-16">
        <div className="max-w-2xl mx-auto text-center">
          <svg className="w-8 h-8 text-[#D4C4A8] mx-auto mb-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
          </svg>
          <p className="text-gray-600 font-light leading-relaxed italic">
            "Unfortunately it is not possible for {VENUE_NAME} to accommodate all wedding guests overnight. 
            Please find a list below of nearby accommodation. If you are unsure if you have a room 
            allocated at the venue, please contact us directly to clarify."
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {alternatives.map((hotel) => (
          <div key={hotel.name} className="group p-8 border border-gray-100 hover:border-[#D4C4A8]/40 transition-all bg-white hover:shadow-md flex flex-col justify-between">
            <div>
              <div className="flex justify-between items-start mb-2">
                <h4 className="font-serif-display text-xl text-black group-hover:text-[#8E806A] transition-colors italic">
                  {hotel.name}
                </h4>
              </div>
              <p className="text-sm text-gray-500 font-light leading-relaxed mb-4">
                {hotel.description}
              </p>
              
              <div className="flex items-center space-x-2 mb-4 bg-[#FAF9F6] w-fit px-3 py-1 rounded-full border border-[#F5F2ED]">
                <svg className="w-3.5 h-3.5 text-[#8E806A]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-[10px] tracking-wider font-bold text-[#8E806A] uppercase">
                  {hotel.taxiTime}
                </span>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-gray-50">
              <a 
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(hotel.name + ' Ayr Scotland')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[10px] tracking-[0.2em] font-bold text-[#8E806A]/60 uppercase hover:text-[#5D5445] transition-colors flex items-center"
              >
                View on Map
                <svg className="w-3 h-3 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-16 text-center">
        <p className="text-gray-400 text-xs tracking-widest uppercase font-light">
          We recommend booking early to ensure availability
        </p>
      </div>
    </div>
  );
};